import { render } from "./Slider.vue?vue&type=template&id=f6844012"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import exportComponent from "C:\\PHPStormServer\\s_hmel\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__